import type { Entity as CurriculumEntity } from './dto'

export const curriculumUtils = {
  extractUpperCurriculumKey: (
    lowerTrieKey: CurriculumEntity.TrieKey,
    lowerCurriculumId: CurriculumEntity.Curriculum['id'],
  ) => {
    const regex = new RegExp('.' + lowerCurriculumId, 'g')
    return lowerTrieKey.replace(regex, '')
  },
}
